(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["le-qr-onboarding"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-qr-onboarding]');
    if (!root || root.dataset.eventsBound) return;
    root.dataset.eventsBound = 'true';
    const allowed = new Set(['qr_quick_setup_click','qr_manual_click','qr_warranty_click','qr_help_click','qr_amazon_review_click','qr_amazon_uk_orders_click']);
    const publish = (name, placement) => {
      if (window.Shopify?.designMode || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return false;
      if (typeof window.Shopify?.analytics?.publish !== 'function') return false;
      try {
        const result = window.Shopify.analytics.publish('latent_epicure:' + name, { page: 'usb-c-qr', placement });
        result?.catch?.(() => {});
        return true;
      } catch { return false; }
    };
    let viewed = false;
    const pageView = () => { if (!viewed) viewed = publish('qr_page_view', 'page'); };
    let privacyRequested = false;
    const initialize = () => {
      if (window.Shopify?.customerPrivacy) { pageView(); return; }
      if (privacyRequested || typeof window.Shopify?.loadFeatures !== 'function') return;
      privacyRequested = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) pageView();
      });
    };
    root.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-qr-event]');
      if (!link || !allowed.has(link.dataset.qrEvent)) return;
      publish(link.dataset.qrEvent, link.dataset.qrPlacement);
      if (link.dataset.qrEvent === 'qr_amazon_review_click' && ['set_us','single_us'].includes(link.dataset.qrPlacement)) {
        publish('qr_amazon_' + link.dataset.qrPlacement + '_review_click', link.dataset.qrPlacement);
      }
    });
    document.addEventListener('visitorConsentCollected', pageView);
    window.addEventListener('load', initialize, { once: true });
    initialize();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
